import { c as _c } from "react/compiler-runtime";
// eslint-disable-next-line no-restricted-imports
import NextLink from 'next/link';
import type { ComponentProps, Ref } from 'react';
import { useMemo } from 'react';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import { isLinkExternal, removeAppUrlFromLink } from '#cutils/links/external-link';
import type { UrlObject } from 'url';
import styles from './Link.module.scss';
const BLANK_REL_ATTRIBUTES = 'noopener';
function getRelForExternalLink(rel: string | undefined) {
  if (rel) {
    return `${rel} ${BLANK_REL_ATTRIBUTES}`;
  } else {
    return BLANK_REL_ATTRIBUTES;
  }
}
type Props<RouteType> = Omit<ComponentProps<typeof NextLink>, 'prefetch' | 'href'> & {
  href: __next_route_internal_types__.RouteImpl<RouteType> | UrlObject;
  ref?: Ref<HTMLAnchorElement>;
};
export function Link(t0) {
  const $ = _c(10);
  let {
    href,
    ref,
    ...props
  } = t0;
  const {
    constants: t1
  } = useEnvironment();
  const {
    appUrl
  } = t1;
  const t2 = `^([ ]*${appUrl}/)`;
  let t3;
  if ($[0] !== t2) {
    t3 = new RegExp(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const appUrlRegexp = t3;
  if (typeof href === "string" && !isLinkExternal(href, appUrlRegexp)) {
    let t4;
    if ($[2] !== appUrlRegexp || $[3] !== href) {
      t4 = removeAppUrlFromLink(href.toString(), appUrlRegexp);
      $[2] = appUrlRegexp;
      $[3] = href;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    href = t4;
  }
  if (props.target === "_blank") {
    const {
      children,
      rel,
      ...linkProps
    } = props;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span className={styles.hidden}>(öffnet in einem neuen Fenster)</span>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return <NextLink href={href} rel={getRelForExternalLink(rel)} ref={ref} prefetch={false} {...linkProps}>{children}{t4}</NextLink>;
  } else {
    let t4;
    if ($[6] !== href || $[7] !== props || $[8] !== ref) {
      t4 = <NextLink href={href} ref={ref} prefetch={false} {...props} />;
      $[6] = href;
      $[7] = props;
      $[8] = ref;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
}